// extracted by mini-css-extract-plugin
export default {"container":"ContactPreferences__container--A-m","singleCheckboxContainer":"ContactPreferences__singleCheckboxContainer--fva"};